/* eslint-disable max-len */
export const PastWorkIcon = () => {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M5.5 13.5C5.5 12.3954 6.39543 11.5 7.5 11.5H32.5C33.6046 11.5 34.5 12.3954 34.5 13.5V42.5C34.5 43.6046 33.6046 44.5 32.5 44.5H7.5C6.39543 44.5 5.5 43.6046 5.5 42.5V13.5Z"
        fill="#4D8314"
      />
      <path
        d="M9.5 9.5C9.5 8.39543 10.3954 7.5 11.5 7.5H35.5C36.6046 7.5 37.5 8.39543 37.5 9.5V38.5C37.5 39.6046 36.6046 40.5 35.5 40.5H11.5C10.3954 40.5 9.5 39.6046 9.5 38.5V9.5Z"
        fill="#8ED02D"
      />
      <path
        d="M16.5 2.75C14.9812 2.75 13.75 3.98122 13.75 5.5V33.5C13.75 35.0188 14.9812 36.25 16.5 36.25H40.5C42.0188 36.25 43.25 35.0188 43.25 33.5V5.5C43.25 3.98122 42.0188 2.75 40.5 2.75H16.5Z"
        fill="#C9EF93"
        stroke="#4D8314"
        strokeWidth="1.5"
      />
      <mask
        id="path-4-outside-1_5861_216077"
        maskUnits="userSpaceOnUse"
        x="2.5"
        y="0.5"
        width="43"
        height="47"
        fill="black"
      >
        <rect fill="white" x="2.5" y="0.5" width="43" height="47" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 3.5C15.3954 3.5 14.5 4.39543 14.5 5.5V7.5H11.5C10.3954 7.5 9.5 8.39543 9.5 9.5V11.5H7.5C6.39543 11.5 5.5 12.3954 5.5 13.5V42.5C5.5 43.6046 6.39543 44.5 7.5 44.5H32.5C33.6046 44.5 34.5 43.6046 34.5 42.5V40.5H35.5C36.6046 40.5 37.5 39.6046 37.5 38.5V35.5H40.5C41.6046 35.5 42.5 34.6046 42.5 33.5V5.5C42.5 4.39543 41.6046 3.5 40.5 3.5H16.5Z"
        />
      </mask>
      <path
        d="M14.5 7.5V10.5H17.5V7.5H14.5ZM9.5 11.5V14.5H12.5V11.5H9.5ZM34.5 40.5V37.5H31.5V40.5H34.5ZM37.5 35.5V32.5H34.5V35.5H37.5ZM17.5 5.5C17.5 6.05228 17.0523 6.5 16.5 6.5V0.5C13.7386 0.5 11.5 2.73858 11.5 5.5H17.5ZM17.5 7.5V5.5H11.5V7.5H17.5ZM14.5 4.5H11.5V10.5H14.5V4.5ZM11.5 4.5C8.73858 4.5 6.5 6.73858 6.5 9.5H12.5C12.5 10.0523 12.0523 10.5 11.5 10.5V4.5ZM6.5 9.5V11.5H12.5V9.5H6.5ZM9.5 8.5H7.5V14.5H9.5V8.5ZM7.5 8.5C4.73858 8.5 2.5 10.7386 2.5 13.5H8.5C8.5 14.0523 8.05228 14.5 7.5 14.5V8.5ZM2.5 13.5V42.5H8.5V13.5H2.5ZM2.5 42.5C2.5 45.2614 4.73857 47.5 7.5 47.5V41.5C8.05229 41.5 8.5 41.9477 8.5 42.5H2.5ZM7.5 47.5H32.5V41.5H7.5V47.5ZM32.5 47.5C35.2614 47.5 37.5 45.2614 37.5 42.5H31.5C31.5 41.9477 31.9477 41.5 32.5 41.5V47.5ZM37.5 42.5V40.5H31.5V42.5H37.5ZM34.5 43.5H35.5V37.5H34.5V43.5ZM35.5 43.5C38.2614 43.5 40.5 41.2614 40.5 38.5H34.5C34.5 37.9477 34.9477 37.5 35.5 37.5V43.5ZM40.5 38.5V35.5H34.5V38.5H40.5ZM40.5 32.5H37.5V38.5H40.5V32.5ZM39.5 33.5C39.5 32.9477 39.9477 32.5 40.5 32.5V38.5C43.2614 38.5 45.5 36.2614 45.5 33.5H39.5ZM39.5 5.5V33.5H45.5V5.5H39.5ZM40.5 6.5C39.9477 6.5 39.5 6.05229 39.5 5.5H45.5C45.5 2.73858 43.2614 0.5 40.5 0.5V6.5ZM16.5 6.5H40.5V0.5H16.5V6.5Z"
        fill="white"
        mask="url(#path-4-outside-1_5861_216077)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.3218 14.1153C38.0259 14.8498 37.9989 16.0138 37.2615 16.7152L28.3842 25.1587C27.6708 25.8372 26.5478 25.8372 25.8344 25.1587L21.7372 21.2617C20.9998 20.5603 20.9728 19.3963 21.6769 18.6618C22.3811 17.9273 23.5496 17.9005 24.287 18.6018L27.1093 21.2862L34.7117 14.0553C35.4491 13.354 36.6176 13.3808 37.3218 14.1153Z"
        fill="#043C32"
      />
    </svg>
  );
};
